/**
 * PrimaryButton — vereinheitlichter CTA-Button im Valeszka-Style.
 *
 * Ersetzt manuelle `h-11 bg-[#0A0A0A] text-white` Muster.
 * Variants:
 *   - "primary"   (default) — bg-[#0A0A0A] / white text
 *   - "secondary"           — border-[#0A0A0A] / #0A0A0A text
 *   - "ghost"               — text-[#0A0A0A] no border
 *   - "danger"              — bg-red-600 white
 *   - "success"             — bg-emerald-600 white
 *   - "stx"                 — bg-stx-accent / stx-accent-fg
 *   - "stx-outline"         — border stx-border / text-stx-text
 */
import { forwardRef } from "react";

const VARIANTS = {
  primary:      "bg-[#0A0A0A] text-white border border-[#0A0A0A] hover:bg-[#333] disabled:bg-[#666] disabled:border-[#666]",
  secondary:    "bg-white text-[#0A0A0A] border border-[#0A0A0A] hover:bg-[#F5F5F5]",
  ghost:        "bg-transparent text-[#0A0A0A] border border-transparent hover:bg-[#F5F5F5]",
  danger:       "bg-red-600 text-white border border-red-600 hover:bg-red-700",
  success:      "bg-emerald-600 text-white border border-emerald-600 hover:bg-emerald-700",
  stx:          "bg-stx-accent text-stx-accent-fg border border-stx-accent hover:bg-stx-accent-hover",
  "stx-outline":"bg-transparent text-stx-text border border-stx-border hover:border-stx-accent hover:text-stx-accent",
};

const SIZES = {
  sm: "h-9  px-4 text-xs",
  md: "h-11 px-5 text-sm",
  lg: "h-12 px-6 text-sm",
};

const PrimaryButton = forwardRef(function PrimaryButton(
  {
    variant = "primary",
    size = "md",
    fullWidth = false,
    icon = null,
    trailing = null,
    disabled = false,
    loading = false,
    onClick,
    testId,
    type = "button",
    children,
    className = "",
    ...rest
  },
  ref
) {
  const cls = VARIANTS[variant] || VARIANTS.primary;
  const sz  = SIZES[size] || SIZES.md;
  return (
    <button
      ref={ref}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 font-semibold rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${sz} ${cls} ${fullWidth ? "w-full" : ""} ${className}`}
      {...rest}
    >
      {loading ? (
        <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : (
        icon
      )}
      {children}
      {trailing}
    </button>
  );
});

export default PrimaryButton;
